import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _get from 'lodash/get';
import { setProfileFilters } from 'containers/Auth/actions';
import { makeSelectProfile } from 'containers/Auth/selectors';
import {
  makeSelectAudienceTagsRelations,
  makeSelectInsuranceOptions,
} from 'containers/Main/selectors';
import useAlgoliaLocale from 'components/useAlgoliaLocale';
import useSiteConfigSelector from 'components/useSiteConfigSelector';
import { getFiltersFromProfile } from './utils';

function useProfileFilters() {
  const dispatch = useDispatch();

  const algoliaLocale = useAlgoliaLocale();
  const audienceTagsRelations = useSelector(makeSelectAudienceTagsRelations());
  const profile = useSelector(makeSelectProfile());
  const insuranceOptions = useSelector(makeSelectInsuranceOptions());
  const [profileSiteConfig, insuranceSiteConfig] = useSiteConfigSelector([
    'Profile to Tags/Audiences',
    'Insurance',
  ]);

  useEffect(() => {
    const insuranceLabel = _get(insuranceSiteConfig, [
      'config',
      'label',
      algoliaLocale,
    ]);

    const profileFilters = getFiltersFromProfile({
      profile,
      insuranceOptions,
      audienceTagsRelations,
      profileConfig: _get(profileSiteConfig, 'config.profile', {}),
      insuranceLabel,
      locale: algoliaLocale,
    });

    dispatch(setProfileFilters(profileFilters));
  }, [
    algoliaLocale,
    audienceTagsRelations,
    dispatch,
    insuranceOptions,
    insuranceSiteConfig,
    profile,
    profileSiteConfig,
  ]);
}

export default useProfileFilters;
